import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, deleteData } from '../../services/testimonialsServices';
import { Button, Modal, Form } from 'react-bootstrap';
import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';
import DataTable from 'react-data-table-component';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import {validateFile } from '../../utils/validators';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';
import { isQuillContentEmpty, cleanQuillHtml } from '../../utils/common';

const modules = {
  toolbar: [
    // Font family and size
    [{ 'font': [] }, { 'size': ['small', false, 'large', 'huge'] }],

    // Headings
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    // Text styles
    ['bold', 'italic', 'underline', 'strike'],

    // Subscript / Superscript
    [{ 'script': 'sub' }, { 'script': 'super' }],

    // Blockquote and code block
    ['blockquote', 'code-block'],

    // Color and background
    [{ 'color': [] }, { 'background': [] }],

    // Text alignment and direction (RTL)
    [{ 'align': [] }, { 'direction': 'rtl' }],

    // Ordered / bullet list
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],

    // Indent and outdent
    [{ 'indent': '-1' }, { 'indent': '+1' }],

      ['link'],

    // Clear formatting
    ['clean']
  ]
};
  
const formats = [
  'font', 'size',
  'header',
  'bold', 'italic', 'underline', 'strike',
  'script',
  'blockquote', 'code-block',
  'color', 'background',
  'align', 'direction',
  'list', 'bullet', 'indent',
  'link', 'image', 'video',
];

const Testimonials = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState({});  
   

  const [formData, setFormData] = useState({
    id: null,
    uploadedfile: null, 
    testimonial_alt_img: '',
    testimonial_name: '',
    testimonial_affiliation: '',
    testimonial_desc: ''  
  });
  const [modalType, setModalType] = useState(''); // 'add' or 'edit'
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setselectedData] = useState(null);  
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);


  // Fetch data from API
      const fetchData = useCallback(async () => {
        setLoading(true);  
        try{
        const response = await getData();
        if (response) {
        setData(response);
        }
      }
        catch(error){
        console.error('Failed to fetch data:', error);
          }
        finally {
          setTimeout(() => {
            setLoading(false);
          }, 500);
        }
      }, []);
  
      useEffect(() => {
        fetchData();
      }, [fetchData]);
    
      const validateForm = () => {
      const newErrors = {};
      if (!formData.uploadedfile ) {
        if (!errors.uploadedfile) newErrors.uploadedfile = "Upload Image is required";
      }
      if (!formData.testimonial_alt_img) newErrors.testimonial_alt_img = "Alt Img Name is required";  
      if (!formData.testimonial_name) newErrors.testimonial_name = "Name is required";
      if (!formData.testimonial_affiliation) newErrors.testimonial_affiliation = "Affiliation is required";
      if (isQuillContentEmpty(formData.testimonial_desc)) newErrors.testimonial_desc = "Testimonial Description is required";

      setErrors((prev) => ({ ...prev, ...newErrors }));
      return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);
    };
    
    const handleChange = async (e) => {
      try{
      const { name, value, files } = e.target;
      const file = files?.[0];
      // Create a copy of the current form data
      let updatedData = { ...formData };
      let updatedErrors = { ...errors };
      if (file) {
        const fileType = file.type.includes("image") ? "img" : "pdf";              
        const isValid = await validateFile(file, setErrors,name,fileType);
        if (isValid) {
          updatedData[name] = file;
          updatedErrors[name] = '';
        }
        else{
          return ; // Don't update if invalid
        }
      }
      else{
        updatedData[name] = value;
        if (value) {
        updatedErrors[name] = ''; // Clear error if corrected
      }
      }
      setFormData(updatedData);
      setErrors(updatedErrors);
    }
      catch(error){
        console.error('Error in handleChange:', error);
      }
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      if (!validateForm()) {
        return
      }
      try {
        const form = new FormData();
        form.append('id', formData.id);
        form.append('testimonial_alt_img', formData.testimonial_alt_img);
        form.append('testimonial_name', formData.testimonial_name);
        form.append('testimonial_affiliation', formData.testimonial_affiliation); // Fixed typo
        form.append('testimonial_desc', formData.testimonial_desc);
        form.append('testimonial_desc', cleanQuillHtml(formData.description));        
        form.append('uploadedfile', formData.uploadedfile);
    
        let result;
        
        if (modalType === 'add') {
          result = await addData(form);
        } else if (modalType === 'edit') {
          result = await updateData(form);
        }
    
        if (result?.status === 200) {
          fetchData();
          setShowModal(false);
          toast.success("Saved successfully!", {
                        position: 'top-right',
                        autoClose: 3000,
                      });

        } else {
          toast.error(result.message ||"Failed to update data. Please try again.", {
                                              position: 'top-right',
                                              autoClose: 3000,
                                            });
          console.log((result?.message || "Failed to process request."));
        }
      } catch (error) {
         console.error('Error:', error.message);
      }
    };
    

    const handleDelete = async () => {
      try{
      if (selectedData) {
        const result = await deleteData(selectedData.id);
        if (result.status === 200) {
          fetchData();
          setShowDeleteConfirmModal(false);
          toast.success("Deleted successfully!", {position: 'top-right',autoClose: 3000,
            });
        } else {
          toast.error("Failed to delete getData:" , {
              position: 'top-right',
              autoClose: 3000,
            });
        }
      }
    }
      catch(error){
        console.error('Failed to delete getData:', error);
      };
    };
  
    
  // Handle change for Quill editor
  const handletestimonialChange = (value) => {
      setErrors((prev) => ({ ...prev, testimonial_desc: isQuillContentEmpty(value) ? 'Testimonial Description is required' : '' }));
    setFormData((prev) => ({ ...prev, testimonial_desc: value }));
  };
  
  const openModal = (type, data = { 
    id: null,
    uploadedfile: null, // File input should be reset
    testimonial_alt_img: '',
    testimonial_name: '',
    testimonial_affiliation: '',
    testimonial_desc: '',  
   }) => {
    setModalType(type);
    setFormData(data);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const openDeleteConfirmModal = (data) => {
    setselectedData(data);
    setShowDeleteConfirmModal(true);
  };

  const closeDeleteConfirmModal = () => {
    setShowDeleteConfirmModal(false);
    setselectedData(null);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


   // Memoized filtered data based on search query
    const filteredData = useMemo(() => {
      try{
        if(data){
        const filtered =  data?.filter(
          (data) =>
          data?.testimonial_name?.toLowerCase().includes(searchText?.toLowerCase()) ||
          data?.testimonial_affiliation?.toLowerCase().includes(searchText?.toLowerCase()) 
        );
        const sortedData = [...filtered].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
        return sortedData;
        }
      }
      catch(error){ 
      console.error('Failed to fetch data:', error);
      }  
      }, [data, searchText]);
    

  const columns = [
    {
        name: '#',
        selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
        sortable: false,
        width: '80px',
      },
    {
        name: 'Picture',
        selector: (row) => <img src={row?.testimonial_photo} width="100" alt={row?.testimonial_alt_img||"TestimonialImage"} style={{ width: '60px', height: '40px', objectFit: 'cover' }}
        crossOrigin="anonymous"/>,
        sortable: false,
    },
    
    {
        name: 'Name',
        selector: (row) => row.testimonial_name,
        cell: (row) => (
            <span title={row.testimonial_name}>
              {row.testimonial_name}
            </span>
          ),
        sortable: true,
    },
    {
        name: 'Affilation',
        selector: (row) => row.testimonial_affiliation,
        cell: (row) => (
        <span title={row.testimonial_affiliation}>
          {row.testimonial_affiliation}
        </span>
      ),
        sortable: true,
    },
    {
      name: 'Actions',
      cell: (row) => (
                <div>
                  <Button
                    className="me-2"
                    variant="warning"
                    size="sm"
                    onClick={() => openModal('edit', {
                      id: row.id,
                      uploadedfile: row.testimonial_photo, // File input should be reset
                      testimonial_alt_img: row.testimonial_alt_img, 
                      testimonial_name: row.testimonial_name, 
                      testimonial_affiliation: row.testimonial_affiliation, 
                      testimonial_desc: row.testimonial_desc,      
                    })}
                  >
                    Edit
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => openDeleteConfirmModal(row)}
                  >
                    Delete
                  </Button>
                </div>
              ),
    },
  ];

  useEffect(() => {
      const tooltipMap = {
        'ql-bold': 'Bold',
        'ql-italic': 'Italic',
        'ql-underline': 'Underline',
        'ql-strike': 'Strikethrough',
        'ql-script[value="sub"]': 'Subscript',
        'ql-script[value="super"]': 'Superscript',
        'ql-blockquote': 'Blockquote',
        'ql-code-block': 'Code Block',
        'ql-color': 'Text Color',
        'ql-background': 'Background Color',
        'ql-align': 'Align',
        'ql-direction': 'Text Direction',
        'ql-list[value="ordered"]': 'Ordered List',
        'ql-list[value="bullet"]': 'Bullet List',
        'ql-indent[value="-1"]': 'Outdent',
        'ql-indent[value="+1"]': 'Indent',
        'ql-link': 'Insert Link',
        'ql-clean': 'Clear Formatting',
      };

    const setTooltips = () => {
      Object.entries(tooltipMap).forEach(([selector, title]) => {
        const el = document.querySelector(`.ql-toolbar .ql-formats .${selector}`);
        if (el && !el.title) {
          el.setAttribute('title', title);
        }
      });
    };

    const observer = new MutationObserver((mutations, obs) => {
      const toolbarReady = document.querySelector('.ql-toolbar');
      if (toolbarReady) {
        setTooltips();
        obs.disconnect(); // Stop observing once done
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

  return () => observer.disconnect() // Clean up on unmount
  }, []);

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
            <p className="fs-4">Event Pages / Conference <b>/ Home Testimonials</b></p>
            </div>
            <div className="col-4 text-end">
              <button className="btn btn-primary mb-3" onClick={() => openModal('add')}>Add</button>
              </div>
            </div>
          

          {/* Data Table for data */}
          <DataTable
            columns={columns}
            data={filteredData?filteredData:[]}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
            noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal show={showModal} className="modal-lg" onHide={closeModal} backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title className='fs-3'>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={handleSubmit}>
              <div className='row'>
                    <Form.Group className="col-md-6 mb-3">
                        <Form.Label className='form-label-custom'>
                        Upload Image<small className='text-danger form-label-note'> * </small> <small className="text-primary form-label-note"> (Dimension: 300x300 | Size: 15kb-30kb)</small>
                        </Form.Label>
                        <Form.Control
                            type="file"
                            name="uploadedfile"
                            // value={formData?.uploadedfile}
                            onChange={handleChange}
                            // required ={!formData?.uploadedfile}
                            isInvalid={!!errors.uploadedfile}
                        />
                      <Form.Control.Feedback type="invalid">{errors.uploadedfile}</Form.Control.Feedback>

                  {/* {errors && <div className="text-danger">{errors.uploadedfile}</div>} */}
                    </Form.Group>

                    <Form.Group className="col-md-6 mb-3">
                        <Form.Label className='form-label-custom'>Alt Image Name <small className='text-danger form-label-note'> * </small> </Form.Label>
                        <Form.Control
                            type="text"
                            name="testimonial_alt_img"
                            value={formData.testimonial_alt_img}
                            onChange={handleChange}
                            isInvalid={!!errors.testimonial_alt_img}
                        />
                        <Form.Control.Feedback type="invalid">{errors.testimonial_alt_img}</Form.Control.Feedback>
                    </Form.Group> 

                    <Form.Group className="col-md-6 mb-3">
                    <Form.Label className='form-label-custom'>Name <small className='text-danger'> * </small></Form.Label>
                    <Form.Control
                        type="text"
                        name="testimonial_name"
                        value={formData.testimonial_name}
                        onChange={handleChange}
                        // required
                        isInvalid={!!errors.testimonial_name}
                    />
                    <Form.Control.Feedback type="invalid">{errors.testimonial_name}</Form.Control.Feedback>
                    </Form.Group>    

                  <Form.Group className="col-md-6 mb-3">
                    <Form.Label className='form-label-custom'>Affiliation <small className='text-danger'> * </small></Form.Label>
                    <Form.Control
                        type="text"
                        name="testimonial_affiliation"
                        value={formData.testimonial_affiliation}
                        onChange={handleChange}
                        // required
                        isInvalid={!!errors.testimonial_affiliation}
                    />
                    <Form.Control.Feedback type="invalid">{errors.testimonial_affiliation}</Form.Control.Feedback>  
                  </Form.Group>


                <Form.Group className="mb-3">
                  <Form.Label className="form-label-custom">Testimonial Description <small className='text-danger'> * </small></Form.Label>

                  <div className={`react-quill-editor`}>
                    <ReactQuill
                      value={formData.testimonial_desc}
                      onChange={handletestimonialChange}
                      theme="snow"
                      modules={modules}
                      formats={formats}
                      placeholder="Enter description"
                      className={`${errors.testimonial_desc ? 'border  border-1 border-danger rounded' : ''}`} 
                    />
                  </div>

                  {errors.testimonial_desc && (
                    <div className="invalid-feedback d-block">
                      {errors.testimonial_desc}
                    </div>
                  )}
                </Form.Group>
                    </div>
                <Modal.Footer className='border-0'>
                  <Button variant="secondary" onClick={closeModal}>
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit">
                    {modalType === 'add' ? 'Add' : 'Save'}
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal.Body>
          </Modal>

          {/* Delete Confirmation Modal */}
          <Modal show={showDeleteConfirmModal} onHide={closeDeleteConfirmModal}>
            <Modal.Header closeButton>
              <Modal.Title>Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete this row?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={closeDeleteConfirmModal}>
                Cancel
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                Yes, Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Footer />
        </div>
        )}
      </div>
    </div>
  );
};

export default Testimonials;